export default __webpack_public_path__ + "static/media/025-charter.e670926e.png";